module.exports = __webpack_public_path__ + "static/media/bgm_apeach.4d41549.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/bgm_apeach.mp3
// module id = jpPe
// module chunks = 1